/**
 * BoldZee scroll helper — one place that knows how much of the top of the
 * screen is covered by sticky bars (the header, and on the service store the
 * category tab bar), so every "scroll to this" lands just below them.
 *
 *   BzScroll.to(el)                       smooth-scroll el to the top of the window
 *   BzScroll.to(el, { onlyIfNeeded: true }) same, but only if el is not already visible
 *   BzScroll.keepInView(el)               after something collapses, bring el back
 *                                         if it ended up above / below the screen
 *
 * It also keeps the CSS variable --bz-sticky-offset up to date, which base.css
 * uses as scroll-padding-top so plain #anchor links land correctly too.
 */
(function () {
  if (window.BzScroll) return;

  // Anything that stays stuck to the top of the screen while scrolling.
  // Add data-bz-sticky to any new sticky bar and it is picked up automatically.
  var STICKY_SELECTORS = ['.section-header', '.hb-collection-tab-main', '[data-bz-sticky]'];
  var GAP = 16; // breathing room between the sticky bars and the target

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isAfter(a, b) {
    // true when b comes after a in the page
    return !!(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  /** Height of the sticky bars that will cover `target` once it reaches the top. */
  function stickyOffset(target) {
    var offset = 0;
    STICKY_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (target && (el === target || el.contains(target))) return;
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
        if (cs.display === 'none' || cs.visibility === 'hidden' || !el.offsetHeight) return;
        // A sticky bar that sits *below* the target in the page never covers it.
        if (target && cs.position === 'sticky' && !isAfter(el, target)) return;
        var top = parseFloat(cs.top) || 0;
        offset = Math.max(offset, top + el.offsetHeight);
      });
    });
    return Math.max(0, offset);
  }

  function isComfortablyVisible(el, offset) {
    var r = el.getBoundingClientRect();
    return r.top >= offset - 2 && r.top <= window.innerHeight * 0.6;
  }

  function to(el, opts) {
    if (!el) return;
    opts = opts || {};
    var offset = stickyOffset(el);
    if (opts.onlyIfNeeded && isComfortablyVisible(el, offset)) return;

    var gap = typeof opts.gap === 'number' ? opts.gap : GAP;
    var y = el.getBoundingClientRect().top + window.pageYOffset - offset - gap;
    window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }

  /**
   * Call right after content above `el` collapses (accordions, "show fewer").
   * Checks once the layout has settled and again after a typical CSS
   * transition, and only scrolls if `el` has actually left the screen.
   */
  function keepInView(el) {
    if (!el) return;
    var check = function () {
      var r = el.getBoundingClientRect();
      var offset = stickyOffset(el);
      if (r.top < offset || r.top > window.innerHeight - 80) to(el);
    };
    requestAnimationFrame(function () { requestAnimationFrame(check); });
    setTimeout(check, 420);
  }

  function syncCssVar() {
    document.documentElement.style.setProperty('--bz-sticky-offset', stickyOffset() + GAP + 'px');
  }

  syncCssVar();
  document.addEventListener('DOMContentLoaded', syncCssVar);
  window.addEventListener('load', syncCssVar);
  window.addEventListener('resize', syncCssVar);

  window.BzScroll = { to: to, keepInView: keepInView, offset: stickyOffset };
})();
